<template>
    <v-app-bar
        absolute
        dense
        app
        elevation="1"
        class="teal--text text-darken-3"
        >
            <v-app-bar-nav-icon 
                class="teal--text" 
                @click='setDrawer(!drawer)'/>

        <v-spacer></v-spacer>
        <img src="@/assets/logo.png"/>
        <v-spacer></v-spacer>
        {{$msal.data.user.name}}
        <v-avatar
            color="primary"
            class="ma-2"
            size="38" >
            <v-icon class="white--text">
                mdi-account
            </v-icon>
            
        </v-avatar>
        
        <div><button @click="$msal.signOut()">log out</button></div>
    </v-app-bar>
</template>

<script>
import { mapState, mapMutations } from 'vuex';


export default {
 Name: 'NavBar',
 computed:{
     ...mapState(['drawer']),
     userProfile(){
         return this.$msal.user
     },
 },
 methods:{
     ...mapMutations({
         setDrawer: 'SET_DRAWER',
     })
 }
}
</script>
<style scoped>
  
</style>